import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const LearningStageIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.37555 4.51693C7.37555 4.41128 7.31 4.31687 7.21144 4.28057L3.83943 3.03873C3.4317 2.88891 3.00012 3.19304 3.00012 3.62995L3 10.5558C2.99999 10.934 3.22292 11.2751 3.56848 11.4235C4.55088 11.8454 6.52577 12.6943 7.20008 12.9894C7.28308 13.0257 7.37555 12.9641 7.37555 12.873V4.51693Z" />
    <path d="M8.62445 4.51687C8.62445 4.41122 8.69 4.31681 8.78856 4.28051L12.1606 3.03867C12.5683 2.88885 12.9999 3.19298 12.9999 3.62989L13 10.5558C13 10.9339 12.7771 11.275 12.4315 11.4234C11.4491 11.8453 9.47423 12.6942 8.79992 12.9893C8.71692 13.0257 8.62445 12.9641 8.62445 12.873V4.51687Z" />
  </SvgIcon>
);
